import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { TriangleAlert } from "lucide-react";
import useSWR from "swr";
import Header from "@/components/Header";
import { Card, TextArea, Select, Field } from "@/components/ui-kit";
import { StickySubmit } from "./TemperatureForm";
import { createRecord, updateRecord, getMeta } from "@/lib/api";
import { getUser } from "@/lib/auth";

export default function IncidenceForm() {
  const navigate = useNavigate();
  const editRecord = useLocation().state?.editRecord;
  const { data: meta } = useSWR("meta", getMeta);
  const today  = new Date().toISOString().slice(0, 10);
  const signer = getUser()?.username || "";
  const [form, setForm] = useState(editRecord
    ? { date: editRecord.date, affected_plan: editRecord.affected_plan, description: editRecord.description, corrective_measure: editRecord.corrective_measure, follow_up: editRecord.follow_up || "" }
    : { date: today, affected_plan: "", description: "", corrective_measure: "", follow_up: "" });
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!form.affected_plan || !form.description || !form.corrective_measure)
      return toast.error("Omple els camps obligatoris");
    setSubmitting(true);
    try {
      if (editRecord) await updateRecord("incidence", editRecord.id, { ...form, signer });
      else await createRecord("incidence", { ...form, signer });
      toast.success(editRecord ? "Incidència modificada" : "Incidencia registrada");
      navigate("/history?type=incidence");
    } catch { toast.error("Error desant el registre"); }
    finally   { setSubmitting(false); }
  };

  return (
    <>
      <Header title="Incidencies" />
      <div className="mx-auto max-w-2xl px-4 pb-32 pt-6 sm:px-6 sm:pt-10">
        <div className="animate-fade-up flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ember text-white"><TriangleAlert size={22} /></div>
          <div><div className="label-eyebrow text-ember">Quan calgui</div><h2 className="font-display text-2xl font-bold text-ink sm:text-3xl">Incidencia i mesura correctora</h2></div>
        </div>
        <div className="mt-6 space-y-4">
          <Card><div className="space-y-4">
            <Field label="Data"><input data-testid="incidence-date" type="date" value={form.date} onChange={(e) => set("date", e.target.value)} className="h-14 w-full rounded-xl border border-line bg-white px-4 text-base text-ink outline-none focus:border-terracotta focus:ring-2 focus:ring-terracotta/20" /></Field>
            <Field label="Pla afectat"><Select testid="incidence-plan" value={form.affected_plan} onChange={(e) => set("affected_plan", e.target.value)}><option value="">Tria un pla...</option>{(meta?.plans || []).map((p) => <option key={p} value={p}>{p}</option>)}</Select></Field>
            <Field label="Descripcio detallada de la incidencia"><TextArea testid="incidence-description" rows={4} placeholder="Que ha passat exactament? Quan? On?" value={form.description} onChange={(e) => set("description", e.target.value)} /></Field>
            <Field label="Mesura correctora aplicada"><TextArea testid="incidence-measure" rows={3} placeholder="Quina accio s'ha pres?" value={form.corrective_measure} onChange={(e) => set("corrective_measure", e.target.value)} /></Field>
            <Field label="Resultat / seguiment (opcional)"><TextArea testid="incidence-follow-up" rows={3} placeholder="Com ha quedat? Pendent de revisar?" value={form.follow_up} onChange={(e) => set("follow_up", e.target.value)} /></Field>
          </div></Card>
        </div>
      </div>
      <StickySubmit onClick={submit} disabled={submitting} label={submitting ? "Desant..." : editRecord ? "Desar canvis" : "Desar incidencia"} />
    </>
  );
}
